import React from "react";
import { Link } from "react-router-dom";
import { siteContent } from "../../../constants/site";

type MobileMenuProps = {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isActive: (path: string) => boolean;
};

export const MobileMenuButton: React.FC<MobileMenuProps> = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
}) => {
  return (
    <button
      onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      className="lg:hidden absolute right-0 flex flex-col items-center justify-center w-9 h-9 space-y-1 rounded-md transition-colors duration-300 hover:bg-background-light/40"
      aria-label="Toggle menu"
      aria-expanded={isMobileMenuOpen}
      aria-controls="mobile-nav-menu"
    >
      <span
        className={`block w-5 h-0.5 bg-primary-text transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? "rotate-45 translate-y-2" : ""
        }`}
      ></span>
      <span
        className={`block w-5 h-0.5 bg-primary-text transition-all duration-300 ease-in-out ${
          isMobileMenuOpen
            ? "opacity-0 scale-x-0"
            : "opacity-100 scale-x-100"
        }`}
      ></span>
      <span
        className={`block w-5 h-0.5 bg-primary-text transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      ></span>
    </button>
  );
};

export const MobileMenuPanel: React.FC<MobileMenuProps> = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  isActive,
}) => {
  return (
    <div
      id="mobile-nav-menu"
      className={`lg:hidden relative z-50 overflow-hidden transform-gpu transition-all duration-500 ease-out ${
        isMobileMenuOpen
          ? "max-h-96 opacity-100 translate-y-0"
          : "max-h-0 opacity-0 -translate-y-2"
      }`}
    >
      <ul className="my-1 mb-3 py-3 space-y-1 bg-white border border-border-light rounded-card shadow-card">
        {siteContent.navbar.links.map((link, index) => (
          <li
            key={index}
            className={`transform-gpu transition-all duration-300 ease-out ${
              isMobileMenuOpen
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-1"
            }`}
            style={{
              transitionDelay: isMobileMenuOpen
                ? `${index * 50}ms`
                : "0ms",
            }}
          >
            <Link
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-2.5 text-sm sm:text-base font-bold rounded-md mx-2 transition-colors duration-200 ${
                isActive(link.path)
                  ? "text-primary-text bg-background-light/50"
                  : "text-primary-navText hover:text-primary-text hover:bg-background-light/40"
              }`}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const MobileMenuBackdrop: React.FC<MobileMenuProps> = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
}) => {
  return (
    <div
      className={`lg:hidden fixed inset-0 top-14 sm:top-16 md:top-[72px] z-40 bg-primary-dark/10 transition-all duration-300 ${
        isMobileMenuOpen
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
      onClick={() => setIsMobileMenuOpen(false)}
      aria-hidden="true"
    />
  );
};

